/*
 * @Author: kevinqq 350910378@qq.com
 * @Date: 2025-03-06 16:15:48
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-03-08 20:10:13
 * @FilePath: \baishu_react_ui\src\components\dashboard\BsyDashRichText\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import BraftEditor from "braft-editor";
import "braft-editor/dist/index.css";
import "./index.css";
class BsyDashRichText extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className={"rich-text-page rich-text-page-show " + this.props.mode}>
        {/* <div className='par-box'>{parse(this.props.richText.html || "")}</div> */}
        {this.props.richText.html && (
          <BraftEditor
            value={BraftEditor.createEditorState(
              this.props.richText.html || ""
            )}
            readOnly
          ></BraftEditor>
        )}

        {!this.props.richText.html && (
          <div className="no-data">
            <span>{React.language("data.content.empty")}</span>
            {this.props.mode === "edit" ? (
              <span className="setting-btn" onClick={this.props?.onConfig}>
                {React.language("edit")}
              </span>
            ) : (
              ""
            )}
          </div>
        )}
      </div>
    );
  }
}
export default BsyDashRichText;
